<template>
    <div>
        <el-form label-width="160px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('operation.rule.ruleTemplateName') + '：'">
                        <span class="normal-label">{{ dataForm.template }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="$route.name !== 'checkStandardsDetail'">
                    <el-form-item :label="$t('operation.rule.industry') + '：'">
                        <span class="normal-label">{{ dataForm.industryName }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-button size="small" class="sys-btn-default" @click="goEdit" style="float: right;"
                        v-if="$route.name !== 'checkStandardsDetail'" v-permission="ruleListEdit">{{ $t('common.edit')
                        }}</el-button>
                </el-col>
            </el-row>

            <div class="title sys-split-line"> {{ $t('operation.rule.content') }}</div>

            <RuleTree ref="limitSet" :acitonType="1"></RuleTree>

        </el-form>
    </div>
</template>

<script>
import RuleTree from './ruleTree.vue'
export default {
    props: {
        dataForm: {
            type: Object,
            default: {}
        },
    },
    watch: {
        dataForm(newVal, oldVal) {
            this.dataForm = newVal;
        }
    },
    components: {
        RuleTree
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
        goEdit() {
            this.$emit('updateType');
        },
    }
}
</script>